var stripe = Stripe('pk_live_51JnBeuBGiyWDhGSVJqcNeIGMJHAaZUn0QDsvXX6Ymz3L8Ce0pO3xD1JoPq1igb7xPPBc0OnxGSSt5W9RLYv4Wb3c00ZGWyZo8R');

// firebase.functions().useFunctionsEmulator('http://localhost:5001');

class CustomCheckout extends HTMLElement {
    constructor() {
        super();

        this.$cartTotal = this.querySelector('#cart-total');
        this.$shippingProviders = this.querySelector(".shipping-providers");
        // let $shippingLoader = this.querySelector(".shipping-loader");
        this.$shippingInputs = {
            'total-weight': this.querySelector('.shipping-address #total-weight'),
            'first-name': this.querySelector('.shipping-address #first-name'),
            'last-name': this.querySelector('.shipping-address #last-name'),
            'street': this.querySelector('.shipping-address #street'),
            'street-number': this.querySelector('.shipping-address #street-number'),
            'interior-number': this.querySelector('.shipping-address #interior-number'),
            'postal-code': this.querySelector('.shipping-address #postal-code'),
            'street-2-col': this.querySelector('.shipping-address #street-2-col'),
            'street-2-del': this.querySelector('.shipping-address #street-2-del'),
            'city': this.querySelector('.shipping-address #city'),
            'state': this.querySelector('.shipping-address #state'),
            'country': this.querySelector('.shipping-address #country'),
            'email': this.querySelector('.shipping-address #email'),
            'phone': this.querySelector('.shipping-address #phone'),
        }
        this.$paymentInputs = {
            'card-number': this.querySelector('.payment-methods #card-number'),
            'exp-date': this.querySelector('.payment-methods #exp-date'),
            'cvv': this.querySelector('.payment-methods #cvv'),
            'payment-method-id': this.querySelector('.payment-methods #payment-method-id'),
            'issuer': this.querySelector('.payment-methods #issuer'),
            'installments': this.querySelector('.payment-methods #installments'),
        }
        this.$paymentAddressInputs = {
            'first-name': this.querySelector('.payment-address #payment-first-name'),
            'last-name': this.querySelector('.payment-address #payment-last-name'),
            'street': this.querySelector('.payment-address #payment-street'),
            'street-number': this.querySelector('.payment-address #payment-street-number'),
            'interior-number': this.querySelector('.payment-address #payment-interior-number'),
            'postal-code': this.querySelector('.payment-address #payment-postal-code'),
            'street-2-col': this.querySelector('.payment-address #payment-street-2-col'),
            'street-2-del': this.querySelector('.payment-address #payment-street-2-del'),
            'city': this.querySelector('.payment-address #payment-city'),
            'state': this.querySelector('.payment-address #payment-state'),
            'country': this.querySelector('.payment-address #payment-country'),
        }

        this.$paymentMethods = this.querySelectorAll('.payment-methods input[name="attributes[payment-method]"]');

        this.$paymentAddressEqual = this.querySelectorAll('.payment-address input[name="attributes[address-equal]"]');

        this.$submitBtn = this.querySelector('#submit');

        this.$shippingMethods = [];

        let stripeElements = stripe.elements();

        // this.$stripeInputs['card-number'] = stripeElements.create('cardNumber');
        // this.$stripeInputs['exp-date'] = stripeElements.create('cardExpiry');
        // this.$stripeInputs['cvv'] = stripeElements.create('cardCvc');

        // this.$stripeInputs['card-number'].mount('#stripe-card-number');
        // this.$stripeInputs['exp-date'].mount('#stripe-exp-date');
        // this.$stripeInputs['cvv'].mount('#stripe-cvv');

        this.$stripeInputs = {
            'card-number': stripeElements.create('cardNumber'),
            'exp-date': stripeElements.create('cardExpiry'),
            'cvv': stripeElements.create('cardCvc'),
        }

        for (let field in this.$stripeInputs) {
            let $input = this.$stripeInputs[field];
            $input.mount(`#stripe-${field}`);
            let $container = document.querySelector(`#stripe-${field}`);
            $input.on('change', function (event) {
                if (!event.error) {
                    $container.classList.remove("not-valid");
                    if (event.complete) {
                        $container.classList.add("valid");
                    } else {
                        $container.classList.remove("valid");
                    }
                } else {
                    $container.classList.remove("valid");
                    $container.classList.add("not-valid");
                }
            });
        }

        this.mxnFormatter = Intl.NumberFormat('es-MX', {
            style: "currency",
            currency: "MXN",
            minimumFractionDigits: 2
        });

        this.$submitBtn.onclick = () => {
            console.log('submit');
            this.submit();
            this.dispatchEvent(new Event('submit', { bubbles: true }));
        }

        document.addEventListener('cartChange', (e) => {
            console.log('cartChange');
            this.getCart().then(cart => {
                console.log(cart);
                if (cart.item_count == 0) {
                    this.classList.add('hidden');
                }
                this.$cartTotal.innerText = this.formatMoney(cart.total_price / 100);
                this.$shippingInputs['total-weight'].value = cart.total_weight;
                this.onRateChange();
            });
        });

        for (let $pM of this.$paymentMethods) {
            $pM.onchange = (e) => {
                if ($pM.checked) {
                    this.updateCartAttributes({ "payment-method": $pM.value });
                }
            }
        }

        for (let $pA of this.$paymentAddressEqual) {
            $pA.onchange = (e) => {
                if ($pA.checked) {
                    this.updateCartAttributes({ "address-equal": $pA.value });
                }
            }
        }

        this.$shippingInputs['postal-code'].addEventListener("change", (e) => {
            if (this.$shippingInputs['postal-code'].checkValidity()) {
                this.getZipData(this.$shippingInputs).then(() => {
                    this.onRateChange();
                }).catch((err) => {
                    console.error(err.message);
                });
            }
        });

        this.$shippingInputs['total-weight'].addEventListener("change", this.onRateChange);

        this.$paymentAddressInputs['postal-code'].addEventListener("change", (e) => {
            if (this.$paymentAddressInputs['postal-code'].checkValidity()) {
                this.getZipData(this.$paymentAddressInputs);
            }
        });


        for (let field in this.$shippingInputs) {
            let $input = this.$shippingInputs[field];
            if ($input.value) {
                if ($input.checkValidity()) {
                    $input.classList.remove("not-valid");
                    $input.classList.add("valid");
                } else {
                    $input.classList.remove("valid");
                    $input.classList.add("not-valid");
                }
            }

            switch (field) {
                case 'street-number':
                case 'postal-code':
                    $input.oninput = function (e) {
                        this.value = this.value ? this.value.replace(/\D/g, '') : '';
                    }
                    break;
                case 'phone':
                    $input.oninput = function (e) {
                        let phone = this.value ? this.value.replace(/\D/g, '') : '';
                        this.value = phone.slice(-10);
                    }
                    break;
                case 'email':
                    $input.oninput = function (e) {
                        this.value = this.value ? this.value.toLowerCase().replace(/\s/g, '') : '';
                    }
                    break;
                default:
            }
            $input.onchange = (e) => {
                let data = this.shippingValues;
                if ($input.checkValidity()) {
                    this.updateCartAttributes(data);
                    $input.classList.remove("not-valid");
                    if ($input.value) {
                        $input.classList.add("valid");
                    } else {
                        $input.classList.remove("valid");
                    }
                } else {
                    if (!$input.value) {
                        this.updateCartAttributes(data);
                    }
                    $input.reportValidity();
                    $input.classList.remove("valid");
                    $input.classList.add("not-valid");
                }
            }
        }

        for (let field in this.$paymentInputs) {
            let $input = this.$paymentInputs[field];
            if ($input.value) {
                if ($input.checkValidity()) {
                    $input.classList.remove("not-valid");
                    $input.classList.add("valid");
                } else {
                    $input.classList.remove("valid");
                    $input.classList.add("not-valid");
                }
            }
            switch (field) {
                case 'card-number':
                    $input.oninvalid = () => { $input.setCustomValidity('Ingrese los 16 dígitos de su tarjeta'); }
                    $input.oninput = (e) => {
                        $input.setCustomValidity('');
                        $input.value = $input.value ? $input.value.replace(/\D/g, '') : '';
                        // if ($input.value.length >= 6) {
                        //     let bin = $input.value.substring(0, 6);
                        //     this.getCart().then(cart => {
                        //         let shippingProvider = this.shippingProvider;
                        //         let transactionAmount = shippingProvider.TotalPrice + (cart.total_price / 100);

                        //         console.log(transactionAmount);
                        //         mp.getInstallments({ amount: `${transactionAmount}`, bin }).then((res) => {
                        //             console.log(res);
                        //             let paymentMethodId = res[0]['payment_method_id'];
                        //             let issuerId = res[0]['issuer'].id;
                        //             let installments = res[0]['payer_costs'][0].installments;
                        //             this.$paymentInputs['payment-method-id'].value = paymentMethodId;
                        //             this.$paymentInputs['issuer'].value = issuerId;
                        //             this.$paymentInputs['installments'].value = installments;
                        //         });
                        //     });
                        // }
                    }
                    break;
                case 'cvv':
                    $input.oninput = function (e) {
                        this.value = this.value ? this.value.replace(/\D/g, '') : '';
                    }
                    break;
                case 'exp-date':
                    $input.oninvalid = () => { $input.setCustomValidity('MM/AAAA Ingrese 2 números para el més y 4 números para el año'); }
                    $input.oninput = function (e) {
                        $input.setCustomValidity('');
                        this.value = this.value ? this.value.replace(/[^\d\/]/g, '') : '';
                        if (e.data) {
                            if (this.value.length == 2) {
                                this.value = this.value + '/';
                            }
                        }
                    }
                    break;
                default:
            }
            $input.onchange = function (e) {
                this.setCustomValidity('');
                if (this.checkValidity()) {
                    this.classList.remove("not-valid");
                    if (this.value) {
                        this.classList.add("valid");
                    } else {
                        this.classList.remove("valid");
                    }
                } else {
                    this.reportValidity();
                    this.classList.remove("valid");
                    this.classList.add("not-valid");
                }
            }
        }

        for (let field in this.$paymentAddressInputs) {
            let $input = this.$paymentAddressInputs[field];
            if ($input.value) {
                if ($input.checkValidity()) {
                    $input.classList.remove("not-valid");
                    $input.classList.add("valid");
                } else {
                    $input.classList.remove("valid");
                    $input.classList.add("not-valid");
                }
            }
            switch (field) {
                case 'street-number':
                case 'postal-code':
                case 'phone':
                    $input.oninput = function (e) {
                        this.value = this.value ? this.value.replace(/\D/g, '') : '';
                    }
                    break;
                case 'email':
                    $input.oninput = function (e) {
                        this.value = this.value ? this.value.toLowerCase().replace(/\s/g, '') : '';
                    }
                    break;
                default:
            }
            $input.onchange = function (e) {
                if (this.checkValidity()) {
                    this.classList.remove("not-valid");
                    if (this.value) {
                        this.classList.add("valid");
                    } else {
                        this.classList.remove("valid");
                    }
                } else {
                    this.reportValidity();
                    this.classList.remove("valid");
                    this.classList.add("not-valid");
                }
            }
        }

        if (this.$shippingInputs['postal-code'].checkValidity()) {
            this.getZipData(this.$shippingInputs).then(() => {
                this.onRateChange();
            }).catch((err) => {
                console.error(err.message);
            });
        } else {
            this.getShippingRates().then((res) => {
                console.log(res);
            });
        }

        this.placeOrder().then((res) => {
            console.log(res.data);
        })

        this.onkeypress = function (e) {
            let key = e.charCode || e.keyCode || 0;
            if (key == 13) {
                e.preventDefault();
                let active = document.activeElement;
                do {
                    if (active.nextElementSibling) {
                        active = active.nextElementSibling;
                        if (active.firstElementChild) {
                            active = active.firstElementChild;
                        }
                    } else {
                        active = active.parentElement;
                    }
                    if (active.tagName == 'INPUT' || active.tagName == 'SELECT') {
                        active.focus();
                    }
                } while ((active.tagName != 'INPUT' && active.tagName != 'SELECT') && active.id != 'custom-checkout')
            }
        }

    }

    formatMoney(value) {
        return this.mxnFormatter.format(value);
    }

    setStatus(status, message) {
        this.style.setProperty('--checkout-message', `"${message}"`);
        this.setAttribute('status', status);
    }

    async placeOrder(data) {
        let shopifyPlaceOrder = firebase.functions().httpsCallable("shopifyPlaceOrder");
        return shopifyPlaceOrder(data);
    }

    async getCart() {
        let res = await fetch('/cart.js')
        return res.json();
    };

    async clearCart() {
        let res = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/json`
            },
            body: JSON.stringify({}),
        })
        return res.json();
    }

    attributeToString(attribute) {
        if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
                attribute = '';
            }
        }
        return attribute.trim();
    }

    async updateCartAttributes(attributes) {
        let data = {};
        for (let attr in attributes) {
            data[attr] = this.attributeToString(attributes[attr]);
        }
        let res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/json`
            },
            body: JSON.stringify({ attributes: data }),
        })
        return res.json();
    };

    async clearCartAttributes() {
        let oldCart = await this.getCart();
        let data = {};
        for (let attr in oldCart.attributes) {
            data[attr] = '';
        }
        return this.updateCartAttributes(data);
    };

    validate() {
        let valid = true;
        for (let field in this.$shippingInputs) {
            let $input = this.$shippingInputs[field];
            if ($input.checkValidity()) {
                $input.classList.remove("not-valid");
                $input.classList.add("valid");
            } else {
                $input.reportValidity();
                $input.classList.remove("valid");
                $input.classList.add("not-valid");
                valid = false;
            }
        }

        let shippingProvider = this.shippingProvider;
        let paymentMethod = this.paymentMethod;
        let paymentAddressEqual = this.paymentAddressEqual;

        if (!shippingProvider || !paymentMethod || !paymentAddressEqual) {
            valid = false;
        }

        if (paymentMethod == 'Tarjeta') {
            for (let field in this.$stripeInputs) {
                let $container = document.querySelector(`#stripe-${field}`);
                if (!$container.classList.contains('valid')) {
                    valid = false;
                }
            }
            // for (let field in this.$paymentInputs) {
            //     let $input = this.$paymentInputs[field];
            //     if ($input.checkValidity()) {
            //         $input.classList.remove("not-valid");
            //         $input.classList.add("valid");
            //     } else {
            //         $input.reportValidity();
            //         $input.classList.remove("valid");
            //         $input.classList.add("not-valid");
            //         valid = false;
            //     }
            // }
        }

        if (paymentAddressEqual == 'false') {
            for (let field in this.$paymentAddressInputs) {
                let $input = this.$paymentAddressInputs[field];
                if ($input.checkValidity()) {
                    $input.classList.remove("not-valid");
                    $input.classList.add("valid");
                } else {
                    $input.reportValidity();
                    $input.classList.remove("valid");
                    $input.classList.add("not-valid");
                    valid = false;
                }
            }
        }

        return valid;
    }

    async getZipData($inputs) {
        try {
            let zip = $inputs['postal-code'].value;
            let $colSelect = $inputs['street-2-col'];
            let preValue = $colSelect.value;
            let zips = [];
            console.log(zip);

            let zipRefs = db.collection('zip').where('d_codigo', '==', zip);
            let zipSnaps = await zipRefs.get();

            $colSelect.innerHTML = '';
            let $option = document.createElement('option');
            $option.value = '';
            $option.innerText = '---';
            $colSelect.appendChild($option);

            zipSnaps.forEach((doc) => {
                let zip = doc.data();
                let z = {
                    col: zip.d_asenta.toUpperCase(),
                    municipality: zip.d_mnpio.toUpperCase(),
                    city: zip.d_ciudad ? zip.d_ciudad.toUpperCase() : zip.d_mnpio.toUpperCase(),
                    state: zip.d_estado.toUpperCase(),
                    country: 'MEXICO',
                };
                let $option = document.createElement('option');
                $option.value = z.col;
                $option.innerText = z.col;
                $colSelect.appendChild($option);
                zips.push(z);
            });

            if (zips.length > 0) {
                $inputs['street-2-del'].value = zips[0].municipality;
                $inputs['city'].value = zips[0].city;
                $inputs['state'].value = zips[0].state;
                $inputs['country'].value = zips[0].country;
            } else {
                $inputs['street-2-del'].value = '';
                $inputs['city'].value = '';
                $inputs['state'].value = '';
                $inputs['country'].value = '';
            }

            $colSelect.value = preValue;
            if (!$colSelect.value) {
                $colSelect.classList.remove("valid");
            }

            console.log(zips);

        } catch (err) {
            throw err;
        } finally {
            // this.connection = '';
        }
    }

    newShippingProvider(rate) {
        let value = {
            CourierName: rate.carrier,
            DeliveryDays: rate.deliveryDays,
            TotalPrice: rate.totalPrice,
            Quote: rate.price,
            // CourierServiceName: rate.CourierServiceName,
            // CourierServiceId: rate.CourierServiceId,
        }

        let template = this.querySelector("template#shipping-providers-template");
        let instance = template.content.cloneNode(true).querySelector('.shipping-provider');
        let radio = instance.querySelector('input');
        let label = instance.querySelector('label');
        let img = instance.querySelector('label img');
        let price = instance.querySelector('label .price');

        radio.id = value.CourierName;
        radio.value = JSON.stringify(value);
        radio.setAttribute('required', '');

        label.htmlFor = value.CourierName;
        price.textContent = this.formatMoney((value.TotalPrice));


        firebase.storage().ref('public/img/' + rate.carrier + '.png').getDownloadURL().then(imgUrl => {
            img.src = imgUrl;
        }).catch((err) => {
            console.log(err.message);
            img.remove();
            let span = document.createElement("SPAN");
            span.textContent = value.CourierName.toUpperCase();
            label.prepend(span);
        });

        // label.appendChild(span);

        radio.onchange = (e) => {
            if (radio.checked) {
                this.updateCartAttributes({ "shipping-provider": radio.value });
                // this.$shippingSubtotal.textContent = this.formatMoney((value.TotalPrice));
                this.getCart().then(cart => {
                    this.$cartTotal.textContent = this.formatMoney((value.TotalPrice) + (cart.total_price / 100));
                });
            }
        }
        return instance;
    }

    async getShippingRates(shippingData) {
        try {
            // let getPaquetexpressRates = firebase.functions().httpsCallable("paquetexpressQuoteShipping");
            // let getFedexRates = firebase.functions().httpsCallable("fedexRateShipping");
            let rateShipping = firebase.functions().httpsCallable("rateShipping");

            let paquetexpressData = { carrier: 'paquetexpress' };
            let dhlData = { carrier: 'dhl' };
            if (shippingData) {
                paquetexpressData.totalWeight = shippingData['total-weight'];
                paquetexpressData.shipping = {
                    postal: shippingData['postal-code'],
                    state: shippingData['state'],
                    country: shippingData['country'],
                };

                dhlData.totalWeight = shippingData['total-weight'];
                dhlData.shipping = {
                    postal: shippingData['postal-code'],
                    state: shippingData['state'],
                    country: shippingData['country'],
                };
            }
            let responses = await Promise.allSettled([
                // getPaquetexpressRates(data),
                // getFedexRates(data),
                rateShipping(paquetexpressData),
                // rateShipping(dhlData),
            ]);
            let rates = [];
            for (let res of responses) {
                if (res.status == "fulfilled") {
                    if (!res.value.data.error) {
                        let rate = res.value;
                        rates.push(rate.data);
                    } else {
                        console.error(res.value.data.error);
                    }
                } else {
                    console.error(res.reason);
                }
            }
            return rates;
        } catch (err) {
            throw err;
        }
    }

    onRateChange() {
        for (let $sM of this.$shippingMethods) {
            $sM.remove();
        }
        this.$shippingMethods = [];
        // this.$shippingSubtotal.innerText = `$ ---`;
        this.$cartTotal.innerText = '';
        this.setStatus('loading-shipping', 'Buscando métodos de envio...');
        this.updateCartAttributes({ "shipping-provider": "" });

        if (this.$shippingInputs['postal-code'].checkValidity()) {
            console.log('rateChange');
            let shippingData = this.shippingValues;
            this.getShippingRates(shippingData).then(async (rates) => {
                let maxRate = 160;
                let extended = true;
                let cart = await this.getCart();
                for (let rate of rates) {
                    if (rate.price < maxRate) {
                        extended = false;
                        break;
                    }
                }
                if (extended) {
                    let defaultRate = {
                        carrier: 'estafeta',
                        deliveryDays: 7,
                        price: 99,
                    }
                    rates.push(defaultRate);
                }
                rates.sort((a, b) => {
                    if (a.price < b.price) {
                        return -1;
                    }
                    if (a.price > b.price) {
                        return 1;
                    }
                    return 0;
                });


                for (let rate of rates) {
                    let totalPrice;
                    if (rate.price < maxRate) {
                        totalPrice = cart.item_count > 1 ? 0 : rate.price - 50;
                    } else {
                        totalPrice = rate.price - (cart.item_count * 50);
                    }
                    totalPrice < 110 && totalPrice > 99 ? totalPrice = 99 : null; 
                    rate.totalPrice = totalPrice < 0 ? 0 : totalPrice;
                }
                console.log(rates);

                // $shippingLoader.classList.add('hide');

                for (let $sM of this.$shippingMethods) {
                    $sM.remove();
                }

                for (let rate of rates) {
                    let $provider = this.newShippingProvider(rate);
                    this.$shippingProviders.appendChild($provider);
                    this.$shippingMethods.push($provider);
                }

                let $firstInput = this.$shippingMethods[0].querySelector('input');
                $firstInput.checked = true;
                $firstInput.dispatchEvent(new Event('change'));

                this.setStatus('', '');

            }).catch((err) => {
                // alert(err);
                this.setStatus('error', err.message);
            });

        } else {
            this.$shippingInputs['postal-code'].reportValidity();
            this.setStatus('error', 'Ingrese un codigo postal válido.');
        }
    }

    async submit() {
        try {
            let cart = await this.getCart();

            this.setStatus('connecting', 'Conectando...');

            if (this.validate()) {

                let shippingProvider = this.shippingProvider;

                let transactionAmount = shippingProvider.TotalPrice + (cart.total_price / 100);

                // let shippingAmmount = JSON.parse(cart.attributes['shipping-provider']).TotalPrice;

                let shippingAddress = this.shippingValues;

                let paymentAddress = this.shippingValues;

                if (this.paymentAddressEqual == 'false') {
                    paymentAddress = this.paymentAddressValues;
                }

                let paymentMethod = this.paymentMethod;

                let cardToken = null;

                let paymentData = null;

                // let deviceId = MP_DEVICE_SESSION_ID;
                let deviceId = null;

                let stripeData = {
                    billing_details: {
                        name: `${paymentAddress['first-name']} ${paymentAddress['last-name']}`,
                        email: shippingAddress['email'],
                        phone: shippingAddress['phone'],
                        address: {
                            city: paymentAddress['city'],
                            country: 'MX',
                            line1: `${paymentAddress['street']} ${paymentAddress['street-number']}`,
                            line2: paymentAddress['interior-number'] ? paymentAddress['interior-number'] : null,
                            postal_code: paymentAddress['postal-code'],
                            state: paymentAddress['state'],
                        }
                    },
                }

                if (paymentMethod == 'Tarjeta') {
                    paymentData = this.paymentValues;

                    stripeData.type = 'card';
                    stripeData.card = this.$stripeInputs['card-number'];



                    // cardToken = await mp.createCardToken({
                    //     cardNumber: paymentData['card-number'],
                    //     cardholderName: `${paymentAddress['first-name']} ${paymentAddress['last-name']}`,
                    //     cardExpirationMonth: paymentData['exp-date'].split('/')[0],
                    //     cardExpirationYear: paymentData['exp-date'].split('/')[1],
                    //     securityCode: paymentData['cvv'],
                    //     // identificationType: 'CPF',
                    //     // identificationNumber: '12345678912',
                    // });
                } else {
                    paymentData = {
                        "payment-method-id": "oxxo"
                    }

                    stripeData.type = 'oxxo';
                }


                let stripeRes = await stripe.createPaymentMethod(stripeData);

                if (stripeRes.error) {
                    throw new Error(stripeRes.error.message);
                } else {
                    cardToken = stripeRes.paymentMethod.id;
                }

                let data = {
                    type: 'create',
                    cart,
                    shippingAddress,
                    shippingProvider,
                    paymentMethod,
                    paymentData,
                    paymentAddress,
                    cardToken,
                    transactionAmount,
                    deviceId
                };

                console.log(data);

                let processStripe = async () => {
                    if (data.status == 'succeeded') {
                        return;
                    }
                    if (data.status == 'requires_action') {
                        let validateRes;
                        switch (data.nextAction.type) {
                            case 'use_stripe_sdk':
                                validateRes = await stripe.handleCardAction(
                                    data.clientSecret
                                );
                                if (validateRes.error) {
                                    throw new Error(validateRes.error.message);
                                }
                                data.type = 'confirm';
                                data.cardToken = validateRes.paymentIntent.id;
                                data.status = undefined;
                                await processStripe();
                                break;
                            case 'oxxo_display_details':
                                this.clearCart();
                                this.clearCartAttributes()
                                validateRes = await stripe.confirmOxxoPayment(data.clientSecret);
                                console.log(validateRes);
                                if (validateRes.error) {
                                    throw new Error(validateRes.error.message);
                                }
                                break;
                            default:
                                throw new Error('Required action not supported!');
                        }
                    } else {
                        let res = await this.placeOrder(data);
                        console.log(res.data);
                        data.redirectUrl = res.data.url;
                        data.ref = res.data.ref;
                        data.status = res.data.status;
                        data.clientSecret = res.data.client_secret;
                        data.nextAction = res.data.next_action;
                        await processStripe();
                    }
                }

                await processStripe();

                this.setStatus('connecting', 'Pedido Exitoso!');

                await this.clearCart();
                await this.clearCartAttributes()
                window.location.replace(data.redirectUrl);

            } else {
                console.log('Not valid');
                this.setStatus('error', 'Porfavor completa todos los campos.');
            }

        } catch (err) {
            // $submitLoader.classList.add("hide");
            console.error(err);
            // alert(err.message);
            this.setStatus('error', `Error: ${err.message}`);
        }

    }

    get shippingValues() {
        let data = {};
        for (let field in this.$shippingInputs) {
            data[field] = this.$shippingInputs[field].value;
        }
        return data;
    }

    get shippingProvider() {
        let shippingMethod = null;
        for (let $sM of this.$shippingMethods) {
            let $input = $sM.querySelector('input');
            if ($input.checked) {
                shippingMethod = JSON.parse($input.value);
            }
        }
        return shippingMethod;
    }

    get paymentMethod() {
        let paymentMethod = null;
        for (let $pM of this.$paymentMethods) {
            if ($pM.checked) {
                paymentMethod = $pM.value;
            }
        }
        return paymentMethod;;
    }

    get paymentAddressEqual() {
        let paymentAddressEqual = null;
        for (let $pA of this.$paymentAddressEqual) {
            if ($pA.checked) {
                paymentAddressEqual = $pA.value;
            }
        }
        return paymentAddressEqual;;
    }

    get paymentValues() {
        let data = {};
        for (let field in this.$paymentInputs) {
            data[field] = this.$paymentInputs[field].value;
        }
        return data;
    }

    get paymentAddressValues() {
        let data = {};
        for (let field in this.$paymentAddressInputs) {
            data[field] = this.$paymentAddressInputs[field].value;
        }
        return data;
    }
}

customElements.define('custom-checkout', CustomCheckout);